"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIManageExtensions = void 0;
function isIManageExtensions(value) {
    return "setup" in value && "start" in value;
}
exports.isIManageExtensions = isIManageExtensions;
//# sourceMappingURL=IManageExtensions.js.map